module.exports = __webpack_public_path__ + "static/groceries-6bfea3883d886349c1f6d59c8a4f2ce1.png";